// import { useLocation } from 'react-router-dom'
import { useNavigate } from '@/hooks/useCustomNavigate'
import { LoginForm } from './LoginForm'
import { useLogin } from '@/hooks/useAuth'

interface LoginData {
  email: string
  password: string
  rememberMe?: boolean
}

export function Login() {
  const navigate = useNavigate()
  // const location = useLocation()
  const { login, isLoading, error } = useLogin()

  const from = '/tool-management'

  const handleLoginSubmit = async (data: LoginData) => {
    await login(data)
    // If from path already has language prefix, use it directly, otherwise use custom navigate
    if (from.match(/^\/(en|zh)\//)) {
      // Path already has language prefix, navigate directly
      window.location.href = from
    } else {
      // Path needs language prefix, use custom navigate
      navigate(from, { replace: true })
    }
  }

  return (
    <LoginForm
      onSubmit={handleLoginSubmit}
      isLoading={isLoading}
      error={error || undefined}
    />
  )
}
